import { render } from "./firmaDocumentov2.vue?vue&type=template&id=df51cfb8&scoped=true"
import script from "./firmaDocumentov2.vue?vue&type=script&lang=js"
export * from "./firmaDocumentov2.vue?vue&type=script&lang=js"

import "./firmaDocumentov2.vue?vue&type=style&index=0&id=df51cfb8&lang=css"
import "./firmaDocumentov2.vue?vue&type=style&index=1&id=df51cfb8&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\reclasin-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df51cfb8"]])

export default __exports__